import BaseAppError from './BaseAppError';

export default class AccessDeniedError extends BaseAppError {
  constructor(message = 'Permission denied') {
    super(message, true, true);
  }
}
